import { UserService } from 'api/generated';
import { UseQueryOptions, useQuery } from 'react-query';

export const useRequestedDocumentsListQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  {
    uid
  }: {
    uid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof UserService.getUsersRequestDocumentCategories1>>,
      unknown,
      Awaited<ReturnType<typeof UserService.getUsersRequestDocumentCategories1>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    ['RequestDocumentsList', ...(queryKey ?? [{ uid }])],
    () => UserService.getUsersRequestDocumentCategories1(uid),
    options
  );
